import { render, staticRenderFns } from "./milestone-details.vue?vue&type=template&id=64059fc6&scoped=true&"
import script from "./milestone-details.vue?vue&type=script&lang=ts&"
export * from "./milestone-details.vue?vue&type=script&lang=ts&"
import style0 from "./milestone-details.vue?vue&type=style&index=0&id=64059fc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64059fc6",
  null
  
)

export default component.exports